import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

export const AA_MONOMERS_ANALYTICS_ACTIONS = {
  OPENED_AA_MONOMER_LIBRARY: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'opened_aa_monomer_library',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CREATED_AA_MONOMER: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'created_aa_monomer',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  EDITED_AA_MONOMER: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'edited_aa_monomer',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ARCHIVED_AA_MONOMER: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'archived_aa_monomer',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UNARCHIVED_AA_MONOMER: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'unarchived_aa_monomer',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};
